<template>
  <b-navbar-nav>
    <b-nav-item>
      <b-nav-item class="no-dropdown" to="/">{{$t('message.dashboard')}}</b-nav-item>
    </b-nav-item>
    <b-nav-item-dropdown v-for="navElem in nav" :text="$t('message.script_' + navElem.menu)"
      :key="navElem.menu" dropright :id="navElem.menu">
      <b-dropdown-item v-for="(scriptName, scriptIndex) in navElem.scripts"
        :key="scriptIndex" @click="onScriptElemClick(navElem.menu, scriptName)"
        :id="navElem.menu + '_' + scriptName">
        {{ $t('message.script_' + navElem.menu + '_' + scriptName) }}
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </b-navbar-nav>
</template>

<script>
import { get } from "../http"

export default {
  name: "ScriptsNavMenu",

  data() {
    return {
      nav: []
    }
  },

  created() {
    this.getNav();
  },

  methods: {
    getNav() {
      get("/scripts_nav").then(
        resp => {
          this.nav = resp.data;
        },
        err => {
          console.log("err", err);
        }
      )
    },

    onScriptElemClick(menuName, scriptName) {
      this.$router.replace("/general_script/" + menuName + "/" + scriptName)
    }
  }
}
</script>
